var map = {
	"./AI TTS.png": "ed79",
	"./AI TTS.svg": "b6d4",
	"./Chat Bot.png": "e3f7",
	"./Chat Bot.svg": "3389",
	"./Custom AI.svg": "f4cb",
	"./Custom Stickers.svg": "df7d",
	"./Global AI.svg": "6423",
	"./Global Stickers.png": "ef75",
	"./Global Stickers.svg": "19bc",
	"./Power Stickers.png": "eb44",
	"./Reward Stickers.png": "78a5",
	"./Reward Stickers.svg": "784f",
	"./Settings.svg": "6193",
	"./Stick Vision.png": "f55c",
	"./Stick Vision.svg": "860d",
	"./Sticker Party.png": "1bc4",
	"./Stickers.png": "a040",
	"./Stickers.svg": "b459",
	"./TTS Stickers.png": "3120",
	"./chart.svg": "0afa",
	"./diamond.svg": "5f77",
	"./mic.png": "72c6",
	"./mic.svg": "1a30"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec5d";